import * as React from 'react';
import { IBoxProps } from '@lce/slice';

import * as Styled from './Container.style';

export interface IContainerProps extends IBoxProps {
  width?: number;
}

export const Container: React.FC<IContainerProps> = ({ px = 4, width = 1400, ...props }) => (
  <Styled.Container data-testid="Container" px={ px } width={ [ '100%', width ] } { ...props } />
);
